import { DatePicker } from '@components/core-ui/form-elements/DatePicker';
import CloseIcon from '@components/icons/Close.svg';
import { TJobsFilter } from 'app/types/TJobsFilter';
import { useState } from 'react';
import { firstDayOfCurrentMonth } from './helpers/firstDayOfCurrentMonth';
import { firstDayOfCurrentWeek } from './helpers/firstDayOfCurrentWeek';
import { getSelectedDateFilterValue } from './helpers/getSelectedDateFilterValue';
import { startOfCurrentDay } from './helpers/startOfCurrentDay';
import { ButtonsWrapper } from './styles/ButtonsWrapper';
import { Close } from './styles/Close';
import { FilterTitle } from './styles/FilterTitle';
import { SuggestionButtonsWrapper } from './styles/SuggestionButtonsWrapper';
import { Wrapper } from './styles/Wrapper';
import { TProps } from './types/TProps';
import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';

export const Filter = ({ filter, setFilter, close, hideHeader = false }: TProps) => {
  const [tempDateFilterSelected, setTempDateFilterSelected] = useState(getSelectedDateFilterValue(filter));
  const [tempFilter, setTempFilter] = useState(filter);

  const tempSubmit = () => {
    setFilter(tempFilter);
    close();
  };
  const tempClose = () => {
    setTempFilter(filter);
    close();
  };

  return (
    <Wrapper>
      {hideHeader ? null : (
        <>
          <FilterTitle>Filters</FilterTitle>
          <Close onClick={tempClose}>
            <CloseIcon />
          </Close>
        </>
      )}

      <div className="label">Jobs submitted</div>
      <div className="datepicker-wrapper">
        <DatePicker
          label="From"
          minDate={new Date(0)}
          maxDate={tempFilter.to || new Date()}
          value={tempFilter.from}
          onChange={(date: Date | null) => setTempFilter({ ...tempFilter, from: date ?? undefined })}
        />
      </div>

      <div className="datepicker-wrapper">
        <DatePicker
          label="To"
          minDate={tempFilter.from}
          maxDate={new Date()}
          value={tempFilter.to}
          onChange={(date: Date | null) =>
            setTempFilter((v: TJobsFilter) => {
              const newVal: TJobsFilter = Object.assign({}, v);
              let newDate;
              if (date) {
                const dateObj = new Date(date);
                dateObj.setHours(23);
                dateObj.setMinutes(59);
                newDate = dateObj;
              }
              newVal.to = newDate;
              return newVal;
            })
          }
        />
      </div>

      <SuggestionButtonsWrapper>
        <OutlinedButton
          className="w-full"
          disabled={tempDateFilterSelected === 'today'}
          onClick={() => {
            setTempFilter((v: TJobsFilter) => {
              const newVal = Object.assign({}, v);
              newVal.from = startOfCurrentDay();
              newVal.to = new Date();
              return newVal;
            });
            setTempDateFilterSelected('today');
          }}
        >
          Today
        </OutlinedButton>

        <OutlinedButton
          className="w-full"
          disabled={tempDateFilterSelected === 'week'}
          onClick={() => {
            setTempFilter((v: TJobsFilter) => {
              const newVal = Object.assign({}, v);
              newVal.from = firstDayOfCurrentWeek();
              newVal.to = new Date();
              return newVal;
            });
            setTempDateFilterSelected('week');
          }}
        >
          This week
        </OutlinedButton>

        <OutlinedButton
          className="w-full"
          disabled={tempDateFilterSelected === 'month'}
          onClick={() => {
            setTempFilter((v: TJobsFilter) => {
              const newVal = Object.assign({}, v);
              newVal.from = firstDayOfCurrentMonth();
              newVal.to = new Date();
              return newVal;
            });
            setTempDateFilterSelected('month');
          }}
        >
          This month
        </OutlinedButton>
      </SuggestionButtonsWrapper>

      <ButtonsWrapper>
        <OutlinedButton
          onClick={() => {
            setTempFilter((v: TJobsFilter) => {
              const newVal = Object.assign({}, v);
              newVal.from = undefined;
              newVal.to = undefined;
              return newVal;
            });
            setTempDateFilterSelected('');
            setFilter((v: TJobsFilter) => {
              const newVal = Object.assign({}, v);
              newVal.from = undefined;
              newVal.to = undefined;
              return newVal;
            });
            close();
          }}
        >
          Reset
        </OutlinedButton>
        <Button onClick={tempSubmit}>Apply</Button>
      </ButtonsWrapper>
    </Wrapper>
  );
};
